<template>
  <div class="card" id="video">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">Video</h3>
      <AddVideo
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID"
        v-bind:showSaveButton="showSaveButton"
      />
    </nav>
    <hr />
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers"
      ></asset-table>
    </div>
  </div>
</template>

<script>
import { db, assetMediaStorageRef } from "../../firebaseDB";
// import AddVideo from "./add-new/addvideo";
import AssetTable from "./assetTable";

export default {
  name: "video",
  components: { AssetTable },
  data: () => ({
    asset_type: "video",
    headers: [
      { th: "Name", name: "name" },
      { th: "Date Uploaded", name: "date_uploaded" },
    //   { th: "Date Modified", name: "date_modified" },
      { th: "Uploaded By", name: "creator" },
      { th: "Duartion (s)", name: "duration" },
    //   { th: "Description", name: "description" },
      // {
      //   th: "Media",
      //   name: "media",
      //   render(row, cell, index) {
      //     if (row.hasOwnProperty("image")) {
      //       return `<a href="${row.image.imageURL}" target="_blank">
      //             <img src="${row.image.imageURL}" style="width: 50px; height: 50px">
      //           </a>`;
      //     } else if (row.hasOwnProperty("video")) {
      //       return `<button type="button" class="btn btn-default"></button>`;
      //     } else {
      //       return "";
      //     }
      //   },
      // },
    ],
    dialog: "",
    updated: false,
    showSaveButton: true,
    editedItem: {
      id: null,
      name: "",
      video: {
        videoName: "",
        videoFile: "",
        videoURL: "",
        videoLength: null,
      },
      service: "",
      description: "",
      soundType: "",
    },
    defaultItem: {
      id: null,
      name: "",
      video: {
        videoName: "",
        videoFile: "",
        videoURL: "",
        videoLength: null,
      },
      service: "",
      description: "",
      soundType: "",
    },
    editedID: -1,
    editedIndex: -1,
    tableData: [],
  }),
  methods: {
    saveSetDesign(updatedData) {
      const currentdate = new Date();
      const datetime =
        currentdate.getDate() +
        "/" +
        (currentdate.getMonth() + 1) +
        "/" +
        currentdate.getFullYear() +
        " @ " +
        currentdate.getHours() +
        ":" +
        currentdate.getMinutes() +
        ":" +
        currentdate.getSeconds();
      setTimeout(() => {
        let updates = {};
        if (!updatedData.id) {
          updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key;
          updates[
            `asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`
          ] = this.$store.state.user.email;
          updates[
            `asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`
          ] = datetime;
        }
        updates[
          `asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`
        ] = datetime;
        updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] =
          updatedData.name || "";
        updates[`asset_data/${this.asset_type}/${updatedData.id}/filename`] =
          updatedData.video.videoName || "";
        updates[`asset_data/${this.asset_type}/${updatedData.id}/service`] =
          updatedData.service || "";
        updates[`asset_data/${this.asset_type}/${updatedData.id}/description`] =
          updatedData.description || "";
        updates[`asset_data/${this.asset_type}/${updatedData.id}/soundType`] =
          updatedData.soundType || "";
        updates[`asset_data/${this.asset_type}/${updatedData.id}/duration`] =
          updatedData.video.videoLength || 0;
        updates[`asset_data/${this.asset_type}/${updatedData.id}/videoType`] =
          "mp4";
        if (updatedData.video && updatedData.video.videoFile) {
          assetMediaStorageRef
            .child(`${updatedData.id}.mp4`)
            .put(updatedData.video.videoFile)
            .then((snapshot) => snapshot.ref.getDownloadURL())
            .catch(function (error) {
              console.log("Error - " + error.message);
            })
            .then((URL) => {
              updatedData.video.videoURL = URL;
            })
            .then((snapshot) => {
              updates[`asset_data/${this.asset_type}/${updatedData.id}/video`] =
                updatedData.video || {
                  videoURL: "",
                  videoFile: "",
                };
              db.ref("assets")
                .update(updates)
                .then((snapshot) => {
                  this.closeDialog();
                  this.updated = true;
                });
            });
        } else {
          db.ref("assets")
            .update(updates)
            .then((snapshot) => {
              this.closeDialog();
              this.updated = true;
            });
        }
      }, 500);
      this.updated = false;
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.editedID = -1;
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = false;
    },
    editItem(item) {
      this.editedIndex = item.index;
      this.editedID = item.id;
      this.editedItem = Object.assign(this.getEditedItem(item.item), item.item);
      this.showSaveButton = item.showSaveButton;
      this.dialog = true;
    },
    getEditedItem(item) {
      let video = {
        videoName: "",
        videoURL: "",
        videoFile: "",
      };
      db.ref(`assets/asset_data/${this.asset_type}/${item.id}/video`)
        .once("value")
        .then((snapshot) => {
          if (snapshot.val() !== null) {
            video = snapshot.val();
          }
        })
        .catch(function (error) {
          console.log("Error - " + error.message);
        });
      return { video };
    },
  },
};
</script>

<style scoped>
#sound {
  scroll-margin: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/video.vue